// FOOTER
export const FOOTER_HEIGHT_MOBILE = 200;
// export const FOOTER_HEIGHT_TABLET_SM = 104;
export const FOOTER_HEIGHT_TABLET_SM = 88;
export const FOOTER_HEIGHT_TABLET_LG = 80;
export const FOOTER_HEIGHT_LAPTOP_SM = 72;
